const setCatalogs = (payload) => {
    return {
        type: 'SET_CATALOGS',
        payload
    }
}

const setCampaigns = (payload) => {
    return {
        type: 'SET_CAMPAIGNS',
        payload
    }
}

export default { setCatalogs, setCampaigns };